module.exports = __webpack_public_path__ + "img/vertical_3_7_5010.73cbd20f.png";